<template>
<div class="addMessageWraper">
    <div class="addMessageContent">
        <div class="top-box">
            <span style="color:#33344a;font-size:16px;font-weight:bold">补充用户信息</span>
            <img style="cursor:pointer"  @click="handleHide" :src="`${envConst.SCMCC_HOST}/images/close.svg`">
        </div>
        <div class="content">
            <div>
                <img :src="`${envConst.SCMCC_HOST}/images/addmsg.svg`">
                <p  style="margin-top:12px;margin-bottom:24px;color:#9191a1">补充信息，获得一对一的产品服务支持</p>
                <Form ref="formaddmsg"
                      :model="msgForm"
                      label-position="left"
                      >
                    <FormItem class="formItem" label="企业行业" >
                        <Select v-model="msgForm.type" placeholder="请选择企业行业" style="width:360px;text-align:left" clearable>
                            <Option v-for="item in typeList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem class="formItem" label="企业规模" >
                        <Select v-model="msgForm.scale" placeholder="请选择企业规模" style="width:360px;text-align:left" clearable>
                            <Option v-for="item in scaleList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem  class="formItem" label="企业地址" >
                        <Select v-model="msgForm.province" clearable style="width:109px;text-align:left;margin-right:16px;" placeholder="请选择省" @on-change="changeProvince">
                            <Option v-for="(item,index) in provinceList" :value="item.districtCode" :key="index">{{ item.districtName }}</Option>
                        </Select>
                        <Select v-model="msgForm.city" clearable style="width:109px;text-align:left;margin-right:16px;" placeholder="请选择市" :disabled="citydisabled" @on-change="changeCity">
                            <Option v-for="(item,index) in cityList" :value="item.districtCode" :key="index">{{ item.districtName }}</Option>
                        </Select>
                        <Select v-model="msgForm.county" clearable style="width:109px;text-align:left" placeholder="请选择区" :disabled="countydisabled">
                            <Option v-for="(item,index) in countyList" :value="item.districtCode" :key="index">{{ item.districtName }}</Option>
                        </Select>
                    </FormItem>
                    <FormItem class="formItem" label="个人姓名" placeholder="请输入您的姓名">
                        <Input v-model="msgForm.name" placeholder="请输入您的姓名" style="width:360px;"/>
                    </FormItem>
                </Form>
            </div>
            <div class="btn-box">
                <Button class="handle-btn jump-btn" @click="handleHide" style="margin-right:16px;">跳过</Button>
                <Button class="handle-btn" @click="submitMsg" type="primary">完成</Button>
            </div>
        </div>
    </div>
</div>
</template>
<script>
import envConst from '../env-const.js'
import { stringify } from 'qs'

export default {
   data(){
       return {
           envConst,
           citydisabled:true,
           countydisabled:true,
           tenantId:'',
           msgForm:{
               scale:'',
               type:'',
               province:'',
               city:'',
               county:'',
               name:''
           },
           scaleList:[],
          //  scaleList:[
          //      {value:'1',label:'1~20'},
          //      {value:'2',label:'20~50'},
          //      {value:'3',label:'50~100'},
          //      {value:'4',label:'100~200'},
          //      {value:'5',label:'200以上'}
          //      ],
            typeList:[
               {value:'1',label:'互联网·软件·通信'},
               {value:'2',label:'房地产·建筑·中介'},
               {value:'3',label:'财会·金融·保险'},
               {value:'4',label:'消费品·零售'},
               {value:'5',label:'汽车·机械·制造'},
               {value:'6',label:'制药·医疗'},
               {value:'7',label:'能源·化工·环保'},
               {value:'8',label:'服务·餐饮·娱乐'},
               {value:'9',label:'广告·传媒·教育'},
               {value:'10',label:'交通·贸易·物流'},
               {value:'11',label:'政府·农林牧渔'}
               ],
            // provinceList:[
            //    {districtCode:'1',districtName:'省1'},
            //    {districtCode:'2',districtName:'省2'}],
            provinceList:[],
            cityList:[],
            countyList:[]
       }
   },
   mounted(){
       this.getProvince();
       this.getScale();
       //  注册携带参数
       this.tenantId = this.$route.params.tenantId;
   },
   methods:{
      //获取企业规模
      getScale(){
           this.$http
             .get('/sctm/directory/getDirDetail?dicCode=TENANT_SCALE_CODE')
             .then(res => {
              if(res.data.returnCode == 0){
                // console.log(res.data.beans);
                let tempList = res.data.beans;
                tempList.forEach(item => {
                  this.scaleList.push({value:item.keyType,label:item.keyValue});
                })
              }else{
                console.log(res.data.returnMessage);
              }
            })
            .catch(function(er) {
               console.log(er)
            })
      },
      //  获取省份下拉选项
       getProvince(){
           this.$http
             .get('/sctm/sctmDictDistrict/getDictCodeByParentCode')
             .then(res => {
              if(res.data.returnCode == 0){
                this.provinceList = res.data.beans;
              }else{
                console.log(res.data.returnMessage);
              }
            })
            .catch(function(er) {
               console.log(er)
            })
       },
      //  获取市下拉选项
       getCity(){
           this.$http
             .get('/sctm/sctmDictDistrict/getDictCodeByParentCode',{
                 params:{
                   parentCode:this.msgForm.province
                 }
             })
             .then(res => {
              if(res.data.returnCode == 0){
                this.cityList = res.data.beans;
              }else{
                console.log(res.data.returnMessage);
              }
            })
            .catch(function(er) {
               console.log(er)
            })
       },
      //  获取区下拉选项
       getCounty(){
           this.$http
             .get('/sctm/sctmDictDistrict/getDictCodeByParentCode',{
               params:{
                   parentCode:this.msgForm.city
               }   
             })
             .then(res => {
              if(res.data.returnCode == 0){
                this.countyList = res.data.beans;
              }else{
                console.log(res.data.returnMessage);
              }
            })
            .catch(function(er) {
               console.log(er)
            })
       },
       handleHide(){
          this.$emit('hideMessageView');
       },
       changeProvince(val){
           if(!val){
               this.citydisabled = true;
               this.countydisabled = true;
               this.msgForm.city = '';
               this.msgForm.county = '';
               this.cityList = [];
               this.countyList = [];
           }else{
             this.getCity();
             this.msgForm.city = '';
             this.countyList = [];
             this.citydisabled = false;
           }
       },
       changeCity(val){
           if(!val){
               this.countydisabled = true;
               this.msgForm.county = '';
               this.countyList = [];
           }else{
             this.getCounty();
             this.countydisabled = false;
           }
       },
       submitMsg(){
         if(this.msgForm.name){
           if(this.msgForm.name.replace(/[^\x00-\xff]/g, 'xx').length > 30){
             this.$Message.error('个人姓名不能超出30个字节');
             return;
           }
         }
         let province = this.msgForm.province;
         let city = this.msgForm.city;
         let county = this.msgForm.county;
         let params = {
           tenantIndustry:'',
           tenantScale:this.msgForm.scale,
           provinceCode:'',
         };
         params.tenantId =  this.tenantId;
         params.contactName = this.msgForm.name;
         this.typeList.forEach(item => {
           if(item.value == this.msgForm.type){
             params.tenantIndustry = item.label;
           }
         });
         this.scaleList.forEach(item => {
           if(item.value == this.msgForm.scale){
             params.tenantScale = item.label;
           }
         });
         this.provinceList.forEach(item => {
           if(item.districtCode == province){
             province = item.districtName;
           }
         });
         this.cityList.forEach(item => {
           if(item.districtCode == city){
             city = item.districtName;
           }
         });
         this.countyList.forEach(item => {
           if(item.districtCode == county){
             county = item.districtName;
           }
         });
         params.provinceCode =province + city + county;
        //  console.log(params);

         this.$http
            .post('/sctm/NKsctmtenantinfos/updateUser',params, {
              transformRequest: [data => stringify(data)]
            })
            .then(res => {
                if(res.data.returnCode == 0){
                  this.$emit('hideMessageView');
                  this.$Message.success('补充信息成功');
                }else{
                  this.$Message.error('修改失败');
                }
            })
            .catch(function(er) {
               console.log(er)
            })
       }
   }
}
</script>
<style lang="stylus" scoped>
.addMessageWraper  
  
  .addMessageContent
    width 492px
    height 550px
    border-radius 5px
    background #fff
    position fixed
    top 50%
    left 50%
    margin-left -246px
    margin-top -225px
    z-index 9999

    .top-box
      width 100%
      height 63px
      padding-left 30px
      padding-right 30px
      display flex
      justify-content space-between
      align-items center
      border-bottom 1px solid #D9E1F6
      margin-bottom 24px

    .content
      width 100%
      text-align center
      padding-left 30px
      padding-right 30px

      Form
        // padding 0 50px
        // box-shadow none

      .location-box
        width 432px
        display flex
        justify-content space-between
        align-items center
        margin-bottom 15px

        .formItem
           margin-bottom 15px
     
      .btn-box
        display flex
        justify-content flex-end

        .handle-btn
          font-size 14px
          padding 7px 20px

        .jump-btn
          margin-right 12px
          background #fff
          border 1px solid #04CBD8
          color #04CBD8

</style>